"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DevicePreviewListPM = void 0;
class DevicePreviewListPM {
    dispose() {
        this.devicePreview.removeObserver(this.doUpdateView);
    }
    constructor(devicePreview, updateView) {
        this.devices = new Map();
        this.doUpdateView = () => {
            const selectedDevice = this.devicePreview.selectedDevice;
            if (selectedDevice) {
                this.updateView({
                    catagorizedDevices: this.devices,
                    selectedDeviceID: selectedDevice.id,
                    selectedDeviceName: selectedDevice.name,
                    selectedDeviceX: selectedDevice.x,
                    selectedDeviceY: selectedDevice.y,
                    useDevicePreview: true,
                });
            }
            else {
                this.updateView({
                    catagorizedDevices: this.devices,
                    selectedDeviceID: '',
                    selectedDeviceName: '',
                    selectedDeviceX: 0,
                    selectedDeviceY: 0,
                    useDevicePreview: false,
                });
            }
        };
        const categories = devicePreview.getCategoryList();
        categories.forEach((category) => {
            const devicesInCategory = devicePreview.getDevicesInCategory(category);
            const deviceList = devicesInCategory.map((device) => {
                const { id, name, x, y } = device;
                return { id, name, x, y };
            });
            if (deviceList.length > 0) {
                this.devices.set(category, deviceList);
            }
        });
        this.devicePreview = devicePreview;
        this.updateView = updateView;
        this.doUpdateView();
        devicePreview.addObserver(this.doUpdateView);
    }
}
exports.DevicePreviewListPM = DevicePreviewListPM;
